import { useState, useEffect } from 'react';
import { useLocation } from '../contexts/LocationContext';
import { getCurrentCountry } from '../utils/locationDetection';
import { Globe, MapPin } from 'lucide-react';

export default function GeoLocationCheck() {
  const { setCountry } = useLocation();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if we already have a selection
    const cached = getCurrentCountry();
    if (!cached) {
      setShowModal(true);
    }
  }, []);

  if (!showModal) return null;

  const handleSelection = (country: 'us' | 'india') => {
    setCountry(country);
    setShowModal(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/80 backdrop-blur-sm transition-opacity duration-300">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden transform transition-all animate-in fade-in zoom-in duration-300">
        <div className="p-8 text-center">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Globe className="w-8 h-8 text-blue-600" />
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-2">Welcome to SwapGifts!</h2>
          <p className="text-gray-600 mb-8">
            To provide the best experience with local currencies and suggestions, please tell us where you're from:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <button
              onClick={() => handleSelection('us')}
              className="flex flex-col items-center justify-center p-6 rounded-xl border-2 border-gray-100 hover:border-blue-600 hover:bg-blue-50 transition-all group"
            >
              <div className="text-4xl mb-3 group-hover:scale-110 transition-transform">🇺🇸</div>
              <span className="font-bold text-gray-900">United States / Global</span>
              <span className="text-xs text-gray-500 mt-1">USD ($)</span>
            </button>

            <button
              onClick={() => handleSelection('india')}
              className="flex flex-col items-center justify-center p-6 rounded-xl border-2 border-gray-100 hover:border-blue-600 hover:bg-blue-50 transition-all group"
            >
              <div className="text-4xl mb-3 group-hover:scale-110 transition-transform">🇮🇳</div>
              <span className="font-bold text-gray-900">India</span>
              <span className="text-xs text-gray-500 mt-1">INR (₹)</span>
            </button>
          </div>

          <div className="mt-8 flex items-center justify-center text-sm text-gray-400">
            <MapPin className="w-4 h-4 mr-2" />
            <span>You can change this anytime in settings</span>
          </div>
        </div>
      </div>
    </div>
  );
}
